(() => {
  if (!document.body.classList.contains('kks-home')) return;
  const body = document.body;
  const carousels = new Map();
  let theme = matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  function applyTheme() {
    body.dataset.kksTheme = theme;
    document.querySelectorAll('[data-kks-theme-toggle]').forEach(button => {
      button.setAttribute('aria-label', theme === 'dark' ? button.dataset.lightLabel : button.dataset.darkLabel);
    });
  }
  function closeMenu() {
    const button = document.querySelector('[data-kks-menu]');
    const menu = document.getElementById('kks-mobile-menu');
    if (menu) menu.hidden = true;
    if (button) {
      button.setAttribute('aria-expanded', 'false');
      button.querySelector('span').textContent = '+';
    }
  }
  function fallback(image) {
    if (!image.isConnected) return;
    const node = document.createElement('div');
    node.className = 'image-fallback';
    node.setAttribute('role', 'img');
    node.setAttribute('aria-label', image.alt);
    node.textContent = image.alt;
    image.replaceWith(node);
  }
  function initialize(scope = document) {
    scope.querySelectorAll('.kks-scope img').forEach(image => {
      if (image.dataset.kksFallback) return;
      image.dataset.kksFallback = 'ready';
      image.addEventListener('error', () => fallback(image), { once: true });
      if (image.complete && !image.naturalWidth) fallback(image);
    });
    scope.querySelectorAll('[data-kks-carousel]').forEach(carousel => {
      const track = carousel.querySelector('[data-kks-carousel-track]');
      if (!track || carousels.has(track)) return;
      const previous = carousel.querySelector('[data-kks-carousel-prev]');
      const next = carousel.querySelector('[data-kks-carousel-next]');
      function update() {
        const end = Math.max(0, track.scrollWidth - track.clientWidth);
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = end <= 2 || track.scrollLeft >= end - 2;
      }
      const observer = new ResizeObserver(update);
      observer.observe(track);
      track.addEventListener('scroll', update, { passive: true });
      track.addEventListener('keydown', carouselKey);
      carousels.set(track, () => {
        observer.disconnect();
        track.removeEventListener('scroll', update);
        track.removeEventListener('keydown', carouselKey);
      });
      update();
    });
    applyTheme();
  }
  function moveCarousel(track, direction) {
    const card = track.querySelector('.category-product-card');
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    const distance = card ? card.getBoundingClientRect().width + gap : track.clientWidth;
    track.scrollBy({ left: direction * distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  }
  function carouselKey(event) {
    if (event.target !== event.currentTarget) return;
    const track = event.currentTarget;
    if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
      event.preventDefault();
      moveCarousel(track, event.key === 'ArrowRight' ? 1 : -1);
    } else if (event.key === 'Home' || event.key === 'End') {
      event.preventDefault();
      track.scrollTo({ left: event.key === 'Home' ? 0 : track.scrollWidth, behavior: 'instant' });
    }
  }
  document.addEventListener('click', event => {
    const carouselButton = event.target.closest('[data-kks-carousel-prev],[data-kks-carousel-next]');
    if (carouselButton) {
      const track = carouselButton.closest('[data-kks-carousel]').querySelector('[data-kks-carousel-track]');
      if (track) moveCarousel(track, carouselButton.hasAttribute('data-kks-carousel-next') ? 1 : -1);
    }
    const toggle = event.target.closest('[data-kks-theme-toggle]');
    if (toggle) { theme = theme === 'dark' ? 'light' : 'dark'; applyTheme(); }
    const button = event.target.closest('[data-kks-menu]');
    if (button) {
      const menu = document.getElementById('kks-mobile-menu');
      const open = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', String(open));
      menu.hidden = !open;
      button.querySelector('span').textContent = open ? '−' : '+';
    }
    if (event.target.closest('#kks-mobile-menu a')) closeMenu();
  });
  document.addEventListener('keydown', event => {
    const menu = document.getElementById('kks-mobile-menu');
    if (event.key === 'Escape' && menu && !menu.hidden) {
      closeMenu();
      document.querySelector('[data-kks-menu]')?.focus();
    }
  });
  matchMedia('(min-width: 701px)').addEventListener('change', event => { if (event.matches) closeMenu(); });
  document.addEventListener('shopify:section:load', () => { initialize(); closeMenu(); });
  document.addEventListener('shopify:section:unload', event => {
    carousels.forEach((cleanup, track) => {
      if (event.target.contains(track)) { cleanup(); carousels.delete(track); }
    });
  });
  initialize();
})();
